import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
const DensityContext = createContext({
  density: "comfortable",
  setDensity: () => {},
  toggleDensity: () => {},
});
export function DensityProvider({
  children,
  storageKey = "tajer-pro-ui-density",
}) {
  const [density, setDensityState] = useState(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      return stored === "compact" ? "compact" : "comfortable";
    } catch {
      return "comfortable";
    }
  });
  const setDensity = (next) =>
    setDensityState(next === "compact" ? "compact" : "comfortable");
  const toggleDensity = () =>
    setDensity(density === "compact" ? "comfortable" : "compact");
  useEffect(() => {
    document.documentElement.dataset.density = density;
    try {
      localStorage.setItem(storageKey, density);
    } catch {}
  }, [density, storageKey]);
  return (
    <DensityContext.Provider
      value={useMemo(() => ({ density, setDensity, toggleDensity }), [density])}
    >
      {children}
    </DensityContext.Provider>
  );
}
export const useDensity = () => useContext(DensityContext);
export const densityClassNames = {
  comfortable: "tp-density-comfortable",
  compact: "tp-density-compact",
};
